import React from 'react';
import { Field } from 'redux-form';
import { components } from '@glowforge/ui-common';

const { Text } = components;

const minPasswordLength = 8; // minimum for user-service

export function validateSetPassword(values) {
  const errors = {};
  if (!values.password) {
    errors.password = 'Required';
  } else if (!values.password || values.password.length < minPasswordLength) {
    errors.password = `Your new password must be at least ${minPasswordLength} characters`;
  }
  if (!values.password_confirmation) {
    errors.password_confirmation = 'Required';
  } else if (values.password_confirmation !== values.password) {
    errors.password_confirmation = 'Your passwords do not match!';
  }

  return errors;
}

export function validateResetPassword(values) {
  const errors = validateSetPassword(values);
  if (!values.current_password) {
    errors.current_password = 'Required';
  } else if (!values.password && (values.current_password === values.password)) {
    errors.password = 'Your new password must be different';
  }

  return errors;
}

export const SetPasswordFields = (passwordLabel = 'Password') => ([
  <Field
    key='newPassword'
    className='newPassword'
    name='password'
    label={passwordLabel}
    type='password'
    component={Text} />,
  <Field
    key='verifyPassword'
    className='verifyPassword'
    name='password_confirmation'
    type='password'
    label={`Confirm ${passwordLabel}`}
    component={Text} />,
]);

export const ResetPasswordFields = () => ([
  <Field
    key='currentPassword'
    className='currentPassword'
    name='current_password'
    label='Current Password'
    type='password'
    component={Text} />,
  ...SetPasswordFields('New Password'),
]);



// WEBPACK FOOTER //
// ./app/components/settings/password-fields.jsx